import { createApp, reactive, toRefs } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css';
import '@/assets/icon/iconfont.css';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.min';
import '@/scss/common.scss';
import '@/scss/fonts.scss';
import installElementPlus from './plugins/element';
import 'element-plus/lib/theme-chalk/index.css';
import _ from 'lodash';
import axios from 'axios';
// import fetchJsonp from 'fetch-jsonp';
import VueAxios from 'vue-axios';
import Api from '@/apis/api.js';
// import highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting';
// import highcharts3d from 'highcharts/highcharts-3d'
import tinycolor from 'tinycolor2';
import * as tool from '@/utils/tool.js';
import qs from 'qs';
import { ElMessage } from 'element-plus';

// 创建事件总线
const eventBus = {
  events: reactive({}),
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  },
  off(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
    }
  },
  emit(eventName, ...args) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(callback => callback(...args));
    }
  },
};

const app = createApp(App);
// 将app实例挂载到window，便于其他模块访问
window.__VUE_APP__ = app;
installElementPlus(app);

app.config.devtools = true;
// 全局api对象挂载
app.config.globalProperties.$_ = _;
app.config.globalProperties.$tool = tool;
app.config.globalProperties.$qs = qs;
app.config.globalProperties.$ElMessage = ElMessage;

app.config.globalProperties.$Api = Api;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$tinycolor = tinycolor;
app.config.globalProperties.$userKey = 'qN_ds-S9-s7ydeOdzgGf5';
// 挂载事件总线到全局
app.config.globalProperties.$eventBus = eventBus;
// app.config.globalProperties.fetchJsonp = fetchJsonp;
/*
缩放函数 会将传入的第一个数值参数根据缩放比例进行转换 
第二个参数为全局的vuex this.$store
此缩放比 适用于全局screen展示  包括预览、编辑和发布

例子  
一个 width：200 x height：100 长方体 
进行自适应缩放 那么现在的数据应该是  
width：$w_Ratio(200,$store) x height：$h_Ratio(100,$store) 自适应screen大小的长方体 
*/
// 处理缩放函数$w_Ratio 根据screen 宽度
app.config.globalProperties.$w_Ratio = (num = 0, store = null) => {
  if (store) {
    return (num * store.state.ProjectInfo.ScreenRatio.w_Ratio) / 100.0;
  }
};
// 处理缩放函数$h_Ratio 根据screen 高度
app.config.globalProperties.$h_Ratio = (num = 0, store = null) => {
  if (store) {
    return (num * store.state.ProjectInfo.ScreenRatio.h_Ratio) / 100.0;
  }
};
// .use(ElMessage, { locale })

app.use(VueAxios, axios).use(store).use(router).mount('#app');
